import type { FormState } from '@/presentation/pages/projects/project-form/utils/form-state.js';

export type ProjectFormErrors = Record<string, string>;

export type ProjectFormErrorLabels = {
    clientRequired: string;
    nameRequired: string;
    abbrRequired: string;
    abbrLength: string;
    invalidEmail: string;
    invalidUrl: string;
};

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const httpsUrlError = (value: string, message: string): string | undefined => {
    const trimmed = value.trim();
    if (!trimmed) {
        return undefined;
    }
    try {
        const url = new URL(trimmed);
        if (url.protocol !== 'https:') {
            return message;
        }
    } catch {
        return message;
    }
    return undefined;
};

export function validateProjectForm(form: FormState, isEdit: boolean, labels: ProjectFormErrorLabels): ProjectFormErrors {
    const errs: ProjectFormErrors = {};
    if (!isEdit && !form.clientId) {
        errs.clientId = labels.clientRequired;
    }
    if (!form.name.trim()) {
        errs.name = labels.nameRequired;
    }
    if (!form.abbreviation.trim()) {
        errs.abbreviation = labels.abbrRequired;
    } else if (form.abbreviation.length < 2 || form.abbreviation.length > 10) {
        errs.abbreviation = labels.abbrLength;
    }
    if (form.clientPmEmail && !EMAIL_REGEX.test(form.clientPmEmail)) {
        errs.clientPmEmail = labels.invalidEmail;
    }
    if (form.agilePmEmail && !EMAIL_REGEX.test(form.agilePmEmail)) {
        errs.agilePmEmail = labels.invalidEmail;
    }
    const reportsUrlError = httpsUrlError(form.reportsUrl, labels.invalidUrl);
    if (reportsUrlError) {
        errs.reportsUrl = reportsUrlError;
    }
    const jiraBaseUrlError = httpsUrlError(form.jiraBaseUrl, labels.invalidUrl);
    if (jiraBaseUrlError) {
        errs.jiraBaseUrl = jiraBaseUrlError;
    }
    return errs;
}
